import c from './app-export-bar.vue';

export default c;
